import { LcAddress } from "@/domains/core"

export type TokenBlacklist = {
  address: LcAddress
  symbol: string
  reason: string
}

export type TokenBlacklistChecker = (address: LcAddress) => boolean

export const isTokenBlacklistChecker: TokenBlacklistChecker = (address: LcAddress) => {
  return tokensBlacklist.some((token) => token.address.equals(address))
}

const tokensBlacklist: TokenBlacklist[] = [
  {
    address: new LcAddress("0xbe979157b869b225422e72b924f3ab47ae9d68f1"),
    symbol: "test",
    reason: "",
  },
  {
    address: new LcAddress("0x2c00f7ff36c3591340b7db47c22c4a413b925e5f"),
    symbol: "test",
    reason: "",
  },
  {
    address: new LcAddress("0xd0224b5edb757fc15f2bf8b49f77a70e0cba1f7a"),
    symbol: "TEST",
    reason: "",
  },
  {
    address: new LcAddress("0x70cd1ce4758876578e1079b001f5b81db2691b9c"),
    symbol: "TEST",
    reason: "",
  },
  {
    address: new LcAddress("0x0e5068618ff02bbc7420694647440b81a9863dd6"),
    symbol: "basedTester",
    reason: "",
  },
]
